import { Component, OnInit } from '@angular/core';
import { MestradoService } from './service/mestrado.service';
import { StringUtilsService } from 'app/shared/string-utils.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'cm-mestrado',
  templateUrl: './mestrado.component.html',
  styleUrls: ['./mestrado.component.scss']
})
export class MestradoComponent implements OnInit {

  carregandoCursosMestrado = true;
  cursosMestrados: Object[] = [];
  environment = environment;

  constructor(
    private mestradoService: MestradoService,
    private stringUtils: StringUtilsService,){}

  ngOnInit() {
    this.mestradoService.listCursoMestrado().subscribe(cursos => {
      const listCursoMestrado = this.cursosMestrados = cursos.cursosposgraduacao;
        //criando o link do mosaico
      this.cursosMestrados = listCursoMestrado.map(curso => {
          const link = this.gerarLinkCurso(curso);
          return { ...curso, link};
      });
      this.carregandoCursosMestrado = false;
    });
  }

  gerarLinkCurso(curso) {
    return `${curso.id}-${this.stringUtils.textoParaSlug(curso.nome)}`;
  }
  
  traduzirModalidade(alias) {
    return alias === 'N' ? 'EAD' : 'Presencial';
  }

}
